import { render, staticRenderFns } from "./fb-series.vue?vue&type=template&id=74658f1c&scoped=true"
import script from "./fb-series.vue?vue&type=script&lang=js"
export * from "./fb-series.vue?vue&type=script&lang=js"
import style0 from "./fb-series.vue?vue&type=style&index=0&id=74658f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74658f1c",
  null
  
)

export default component.exports